import { useState } from 'react' // Importe ReactNode se você estiver usando React version >= 17
import { Button, Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { reabrirAtendimentoById } from '../../../../atendimento/core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useModal } from '../../../../../../components'
import { ID, showError } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface ReabrirAtendimentoModalProps {
  atendimentoId: ID
}

const ReabrirAtendimentoModal: React.FC<ReabrirAtendimentoModalProps> = ({ atendimentoId }) => {
  const { closeModal } = useModal()
  const { refetch } = useQueryResponse()
  const { t } = useT()
  const navigate = useNavigate()

  const [observacao, setObservacao] = useState('')

  const handleCancelAtendimento = async () => {
    if (!observacao) {
      Swal.fire({
        text: 'A observação é obrigatório.',
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
      return
    }

    reabrirAtendimentoById(atendimentoId, observacao)
      .then(() => {
        refetch()
        Swal.fire({
          text: `Atendimento reaberto`,
          icon: 'success',
          buttonsStyling: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
        closeModal()
        navigate('/apps/atendimentosMedicos/lista')
      })
      .catch(showError)
  }

  return (
    <>
      <Form.Group controlId='observacao'>
        <Form.Label>Observação</Form.Label>
        <Form.Control
          type='text'
          placeholder='Digite uma observação'
          value={observacao}
          required={true}
          className={observacao ? '' : 'is-invalid'}
          onChange={(e) => setObservacao(e.target.value)}
        />
      </Form.Group>

      <div className='d-flex justify-content-end mt-6'>
        <Button variant='secondary' onClick={closeModal} className='me-3'>
          {t('common.cancel')}
        </Button>
        <Button variant='danger' onClick={handleCancelAtendimento}>
          Confirmar
        </Button>
      </div>
    </>
  )
}

export { ReabrirAtendimentoModal }
